/* unplugin-vue-components disabled */import { render } from "./CTitle.vue?vue&type=template&id=fb13ce9e&scoped=true&ts=true"
import script from "./CTitle.vue?vue&type=script&lang=ts"
export * from "./CTitle.vue?vue&type=script&lang=ts"

import "./CTitle.vue?vue&type=style&index=0&id=fb13ce9e&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb13ce9e"]])

export default __exports__